<template>
        <div :class="'modal-container sighting-modal' + (sighting.can_vet ? ' sighting-vetting-modal' : '')" v-bind:id="uniqueID">
            <div class="modal-content">
                <div class="modal-close modal-close-cross"></div>
                <section class="feature-large bg--white border--round ">
                    <div class="container sighting-modal">
                        <div class="loading-error" v-show="loading && failed_id">
                            <div class="alert alert-warning">
                                <strong>There was an error loading this record.</strong>
                            </div>
                        </div>
                        <div class="loading-overlay" v-show="loading && !failed_id">
                            <div class="spinner-wrapper">
                                <span class="spinner-text">LOADING</span>
                                <span class="spinner"></span>
                            </div>
                        </div>
                        <div v-if="!loading && editing_record == null">
                            <VettingBar v-model="sighting" @sightingVettingChanged="sightingVettingChanged" @sightingDeleted="sightingDeleted" @deletePhotos="delete_photos=true" />
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="clearfix sighting_header" v-if="!sighting.can_vet_edit || !editing_taxa">
                                        <h3 class="sighting_taxon_name pull-left notranslate" translate="no">{{sighting.taxon_data.common_name}} - 
                                            <small><em>{{sighting.taxon_data.scientific_name}}</em></small>
                                        </h3>
                                        <button v-if="sighting.can_vet_edit && !editing_taxa" @click="editing_taxa = true;" class="btn btn-xs btn-edit-taxon btn-secondary pull-left"><i class="fa fa-pencil"></i></button>
                                        <h5 class="sighting_id pull-right">OC#{{sighting.id}}</h5>
                                    </div>
                                    <div v-if="sighting.can_vet_edit && editing_taxa">
                                        <label><strong>Correct Taxon</strong></label>
                                        <div class="row">
                                            <div class="col-md-8">
                                                <TaxonSelector v-model="correctedTaxon" />
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <button class="btn btn-block btn-xs btn-success" @click="saveEditingTaxon">Save</button>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <button class="btn btn-block btn-xs" @click="clearEditingTaxa">Cancel</button>
                                            </div>
                                        </div>
                                        <br />
                                    </div>
                                    <div v-if="activephoto && (sighting.photos[1] || delete_photos)" class="image-gallery">
                                        <a class="block clearfix text-center" :data-id="activephoto.id" onclick="$('#sightingGallery_' + $(this).attr('data-id')).click();">
                                            <img :src="activephoto.medium" alt="" class="img-responsive" />
                                        </a>
                                        <br />
                                        <div class="row">
                                            <div class="col-3 col-photo-tumbnail" v-for="photo in sighting.photos">
                                                <a @click="activephoto=photo;" :data-original="photo.original">
                                                    <img :src="photo.small" alt="" class="img-responsive" />
                                                </a>
                                                <a :href="photo.large" :id="'sightingGallery_' + photo.id" class="sightingGallery hidden" :data-original="photo.original"></a>
                                                <button v-if="delete_photos" @click="deletePhoto(photo.id)" class="btn btn-xs btn-danger btn-thumbnail-delete"><i class="fa fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="activephoto && (sighting.photos[0] && !delete_photos)" class="image-single">
                                        <a :href="sighting.photos[0].large" class="block clearfix text-center sightingGallery" :data-original="sighting.photos[0].original">
                                            <img :src="sighting.photos[0].medium" alt="" class="img-responsive" />
                                        </a>
                                    </div>
                                    <div v-else class="no-image" >
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="col-sm-7">
                                            <h5>Specimen Notes:</h5>
                                            <div class="boxed boxed--border break">{{sighting.notes}}</div>
                                        </div>
                                        <div class="col-sm-5">
                                            <div v-if="sighting.checklist_data && sighting.checklist_data.datetime">
                                                <strong>Observed on:</strong>  {{sighting.checklist_data.datetime.split('T')[0] | moment(momentDisplayFormat())}}
                                            </div>
                                            <div v-if="sighting.user_data">
                                                <strong>Submitted by:</strong> 
                                                <span v-if="sighting.user_data.email">
                                                    <a :href="'mailto:' + sighting.user_data.email + '?subject=Odonata Central Submission #' + sighting.id">{{sighting.user_data.display_name}}</a>
                                                </span>
                                                <span v-else>{{sighting.user_data.display_name}}</span>
                                                <br /> on {{sighting.created.split('T')[0] | moment(momentDisplayFormat())}}
                                                <div v-if="sighting.checklist_data.certified_observer">
                                                    <span style="color:#fff;" class="label label--inline">Certified Observer</span>
                                                </div>
                                            </div>
                                            <div v-if="sighting.checklist_data.projects">
                                              <strong>Project(s):&nbsp;</strong>
                                              <span v-for="(project, index) in sighting.checklist_data.projects">
                                                 <span v-if="index != 0"> & </span>
                                                {{project.name}}
                                              </span>
                                              <br />
                                              <br />
                                            </div>
                                            <div v-if="sighting.checklist_data && sighting.checklist_data.observer && !editing_checklist">
                                                <strong>Observed by:</strong> <em>{{sighting.checklist_data.observer}}</em>
                                            </div>
                                            <div v-if="sighting.checklist_data && sighting.checklist_data.observer == '' && !editing_checklist">
                                                <strong>Observed by a third party</strong>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <button v-if="sighting.can_edit" @click="editStart()" class="btn btn-primary btn-xs">Edit Record</button>
                                            <router-link class="btn btn-xs" :to="{ name: 'checklist_view', params: { id: sighting.checklist }}">View Checklist</router-link>
                                            <router-link v-if="sighting.can_edit" class="btn btn-xs" :to="{ name: 'checklist_edit', params: { id: sighting.checklist }}">Edit Checklist</router-link>

                                            <button @click="show_request_vetting = true;" v-if="!show_request_vetting && !sighting.can_vet && sighting.can_request_vetting && sighting.status_data.id != this.APIStatuses.pending" class="btn btn-warning btn-xs">Request Vetting</button>
                                        </div>
                                        <div class="col-sm-12" v-if="show_request_vetting && !sighting.can_vet && sighting.can_request_vetting && sighting.status_data.id != this.APIStatuses.pending">
                                            <br />
                                            <strong>Requesting Vetting</strong>
                                            <textarea class="request_vetting_reason" placeholder="Reason for vetting request" v-model="sighting.request_vetting_reason"></textarea>
                                            <button @click="requestVetting()" class="btn btn-warning btn-xs">Submit Vetting Request</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sighting-details">
                                    <dl>
                                        <dt v-if="sighting.status_data">Current Status</dt>
                                        <dd>
                                            <span v-if="sighting.status_data" :class="'badge ' + getBadgeType(sighting.status_data)">{{sighting.status_data.name}}</span>
                                            <span v-if="sighting.outlier" class="badge badge-info badge-outlier">Outlier</span>
                                            <div v-if="sighting.request_vetting">
                                                <hr>
                                                <span class="badge badge-info">Vetting Requested by {{sighting.request_vetting_user_data.display_name}}</span>
                                                <div v-if="sighting.request_vetting_reason">
                                                    <strong>Reason: </strong>
                                                    <em>{{sighting.request_vetting_reason}}</em>
                                                </div>
                                                <hr>
                                            </div>
                                        </dd>
                                        <dt>Count</dt>
                                        <dd v-if="sighting.count && sighting.count > 0">{{sighting.count}}</dd>
                                        <dd v-else>Not Reported</dd>
                                        <dt v-if="sighting.life_stage_data">Life Stage</dt>
                                        <dd v-if="sighting.life_stage_data">{{sighting.life_stage_data.name}}</dd>
                                        <dt v-if="sighting.type_data">Record Type</dt>
                                        <dd v-if="sighting.type_data">
                                            {{sighting.type_data.name}}
                                            <button v-if="sighting.can_vet_edit && !editing_type" @click="editType()" class="btn btn-xs btn-edit-type"><i class="fa fa-pencil"></i></button>
                                            <div v-if="editing_type" class="row row-pull-out">
                                                <div class="col-6">
                                                    <v-select label="name" :options="recordTypes" v-model="newRecordType"></v-select>
                                                </div>
                                                <div class="col-6">
                                                    <button @click="saveType()" class="btn btn-primary btn-sm">Save</button>
                                                    <button @click="stopEditingType()" class="btn btn-sm">Cancel</button>
                                                </div>
                                            </div>
                                        </dd>
                                        <dt v-if="sighting.observer_confidence_data">ID Confidence</dt>
                                        <dd v-if="sighting.observer_confidence_data">{{sighting.observer_confidence_data.name}}</dd>
                                        <dt v-if="sighting.institution && sighting.institution != ''">Institution</dt>
                                        <dd v-if="sighting.institution && sighting.institution != ''" class="notranslate" translate="no">{{sighting.institution}}</dd>

                                        <dt v-if="sighting.vetter_data">Vetted by</dt>
                                        <dd v-if="sighting.vetter_data">{{sighting.vetter_data.display_name}}</dd>
                                        <dt v-if="sighting.vetted_datetime">Vetted Date</dt>
                                        <dd v-if="sighting.vetted_datetime">
                                            {{ sighting.vetted_datetime.split('T')[0] | moment(momentDisplayFormat()) }}
                                        </dd>
                                    </dl>
                                    <div v-if="sighting.can_vet && sighting.status_data.id == this.APIStatuses.pending">
                                        <h5>Decision Notes</h5>
                                        <textarea class="vetter_notes" v-model="sighting.vetter_notes"></textarea>
                                        <div class="alert alert-info alert-small">
                                            Vetters: Please type your name after all decision note entries and add new signed notes after previous ones if necessary.<br />
                                        </div>
                                    </div>
                                    <div v-else-if="sighting.vetter_notes && sighting.vetter_notes != ''">
                                        <h5>Decision Notes</h5>
                                        <div class="boxed boxed--border break boxed-vetter_notes">{{sighting.vetter_notes}}</div>
                                    </div>
                                    <div v-else>
                                        <h5>No Decision Notes</h5>
                                        <hr>
                                    </div>
                                    
                                    <div  v-show="sighting.location_data">
                                        <label>Map Background</label>
                                        <div class="input-select">
                                            <select v-model="gMapType">
                                                <option value="roadmap">Road</option>
                                                <option value="satellite">Satellite</option>
                                                <option value="hybrid">Hybrid</option>
                                                <option value="terrain">Terrain</option>
                                                <option value="plain">Plain</option>
                                            </select>
                                        </div>
                                        <GmapMap
                                            ref="ocSightingMap"
                                            id="ocSightingMap"
                                            :center="coordinates"
                                            :zoom="6"
                                            :options="mapOptions"
                                            class="ocSightingMap"
                                            :map-type-id="this.gMapType"
                                            >
                                            <GmapMarker :position="coordinates" />
                                        </GmapMap>
                                        <span v-if="sighting.location_data.private_property" class="badge badge-warning">This location is on private land.</span>
                                        <Br />
                                        <h5 v-if="sighting.location_data && sighting.location_data.display_name" class="notranslate" translate="no">{{sighting.location_data.display_name}}</h5>
                                        <h5 v-else-if="sighting.location_data.name" class="notranslate" translate="no">{{sighting.location_data.name}}</h5>
                                        <h5 v-if="sighting.jurisdiction_data && sighting.jurisdiction_data.display_name" class="notranslate" translate="no">{{sighting.jurisdiction_data.display_name}}</h5>


                                        <span v-if="sighting.latitude && sighting.longitude">
                                            {{sighting.latitude}}, {{sighting.longitude}}
                                        </span>
                                        <span v-else>
                                            {{sighting.location_data.latitude}}, {{sighting.location_data.longitude}}
                                        </span>

                                        


                                        <div class="alert alert-info" v-if="sighting.old_jurisdiction_data && sighting.old_jurisdiction_data.display_name">
                                            This sighting had mismatched jurisdiction data. The previously selected jursidiction was <strong class="notranslate" translate="no">{{sighting.old_jurisdiction_data.display_name}}</strong>.
                                        </div>

                                        <h5>Location Description</h5>
                                        <div class="boxed boxed--border break">{{sighting.location_data.description}}</div>
                                        <div v-if="sighting.location_notes">
                                            <h5>Location Notes</h5>
                                            <div class="boxed boxed--border">{{sighting.location_notes}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                        <div v-else-if="!loading && editing_record != null">
                            <h3>Editing Record OC#{{sighting.id}}</h3>
                            <SightingEdit v-model="editing_record" @sightingSaved="editSave()" @sightingDeleted="sightingDeleted" @cancel="editCancel()" />
                        </div>
                    </div>
                </section>
            </div>
            <a class="previous-sighting" @click="showSighting($parent.getPreviousSightingID());" v-if="$parent.getPreviousSightingExists()">
                <i class="fa fa-chevron-left"></i>
            </a>
            <a class="next-sighting" @click="showSighting($parent.getNextSightingID());" v-if="$parent.getNextSightingExists()">
                <i class="fa fa-chevron-right"></i>
            </a>
        </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
export default {
    name: 'SightingModal',
    props: ['uniqueID'],
    mounted () {
        var self = this;
        document.addEventListener("modalClosed.modals.mr", function(event) {
            self.setSighting(null);
            self.$emit('modalClosed');
        });

        var parsed_active_sighting = parseInt(this.$route.query.active_sighting);
        if (!isNaN(parsed_active_sighting)) {
            this.showSighting(parsed_active_sighting);
        }        
    },
    data: function(){
        return {
            loading: true,
            sightingID: null,
            sighting:{
            },
            marker: null,
            activephoto:null,
            waiting:false,
            editing_taxa:false,
            editing_type:false,
            editing_record:null,
            correctedTaxon: null,
            recordTypes:[],
            newRecordType:null,
            gMapType:this.$store.state.gmapPreferenceSightingModal,
            failed_id: null,
            show_request_vetting:false,
            mapOptions: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
            },
            delete_photos: false,
        };
    },
    computed: {
        coordinates: function(){
            var defaultcoords = {lat: 41.850033, lng: -87.6500523};
            if (!this.sighting) {
                return defaultcoords;
            }
            if (this.sighting.latitude && this.sighting.longitude) {
                return {lat:this.sighting.latitude , lng:this.sighting.longitude};
            }
            if (this.sighting.location_data) {
                return {lat:this.sighting.location_data.latitude , lng:this.sighting.location_data.longitude }
            }
            return defaultcoords;
        }
    },
    updated: function(){
        this.$nextTick(function () {
            $('.sighting-modal .sightingGallery').magnificPopup({
                type: 'image',
                gallery:{
                    enabled:true
                },
                image:{
                    titleSrc: function(item){
                        return "<a class='original-photo' href='"+ item.el.attr('data-original') +"' target='_blank'><strong>Original Photo</strong></a>"; 
                    }
                }
            });
        })
    },
    methods:{
        deletePhoto:function(photoID){
            if (!confirm("Are you sure you want to permanently delete this photo?")) {
                return;
            }
            var self = this;
            this.API({
                endpoint: 'sighting-photos/' + photoID,
                isDelete:true,
                funcThen: function(response){
                    for (var i = 0; i < self.sighting.photos.length; i++) {
                        if (self.sighting.photos[i] && self.sighting.photos[i].id == photoID) {
                            self.sighting.photos.splice(i, 1);
                            
                            if (self.sighting.photos.length > 0) {
                                self.activephoto = self.sighting.photos[0];
                            }
                            else{
                                self.activephoto = null;
                                self.showSighting(self.sightingID);
                            }
                            break;
                        }
                    }
                    self.$notify({
                      text: 'Photo Deleted',
                      type: 'success',
                    });
                },
                funcCatch: function(error){
                    console.log(error)
                },
            });
        },
        addPlainMapType(){
            this.$nextTick(function () {
                this.$refs.ocSightingMap.$mapPromise.then((map) => {
                    var moonMapType = new google.maps.ImageMapType({
                        getTileUrl: function(a, z) {
                            var f = "/public/oc/plain-map-tiles/z"+z+"x"+a.x+"y"+a.y+".png";
                            return f;
                        },
                        tileSize: new google.maps.Size(256, 256),
                        maxZoom: 9,
                        minZoom: 0,
                        name: 'Plain'
                    });

                    map.mapTypes.set('plain', moonMapType);
                });
            });
        },
        stopEditingType: function(){
            this.recordTypes = [];
            this.newRecordType = null;
            this.editing_type = false;
        },
        saveType: function(){
            if (!this.newRecordType) {
                this.$notify({
                    text: 'Please enter a record type.',
                    type: 'error',
                });
                return;
            }
            var self = this;
            this.API({
                endpoint: 'sightings/' + self.sighting.id,
                isPatch:true,
                postData: {
                    type:self.newRecordType.id
                },
                funcThen: function(response){
                    self.$notify({
                        text: 'Record Type Updated.',
                        type: 'success',
                    });
                    self.stopEditingType();
                    self.showSighting(self.sightingID);
                    self.$emit('sightingModfied', self.sightingID);
                },
                funcCatch: function(error){
                },
            });
        },
        editType: function(){
            var self = this
            this.API({
                endpoint: 'sighting-types',
                funcThen: function(response){
                    self.recordTypes = response.data['sighting_types'];
                }
            });

            this.editing_type = true;
        },
        requestVetting: function(){
            var self = this;
            this.API({
                endpoint: 'sightings/' + self.sighting.id,
                isPatch:true,
                postData: {
                    request_vetting_reason: self.sighting.request_vetting_reason,
                    request_vetting:true
                },
                funcThen: function(response){
                    self.$notify({
                        text: 'Vetting has been requested.',
                        type: 'success',
                    });
                    self.showSighting(self.sightingID);
                    self.$emit('sightingModfied', self.sightingID);
                },
                funcCatch: function(error){
                    if (error.response) {
                        self.api_errors = error.response.data;
                    }
                    else{
                        console.log(error);
                        self.$notify({
                            text: 'There was an error requesting vetting.',
                            type: 'error',
                        });
                    }
                },
            });
        },
        saveEditingTaxon:function(){
            if (!this.correctedTaxon) {
                self.notifyError("Please select the correct taxon.");
                return;
            }

            var self = this;

            this.API({
                endpoint: 'sightings/' + self.sighting.id,
                isPatch:true,
                postData: {
                    taxon:self.correctedTaxon.id
                },
                funcThen: function(response){
                    self.$notify({
                        text: 'Sighting Saved',
                        type: 'success',
                    });
                    var tmpDecisionNotes = self.sighting.vetter_notes;
                    self.showSighting(self.sightingID, function(){
                        self.sighting.vetter_notes = tmpDecisionNotes;
                    });
                },
                funcCatch: function(error){
                    self.$notify({
                      text: 'There was an error saving your data: ' + error.response.data,
                      type: 'error',
                    });
                },
            });
        },
        clearEditingTaxa:function(){
            this.correctedTaxon = null;
            this.editing_taxa = false;
        },
        editStart:function(){
            this.editing_record = JSON.parse(JSON.stringify(this.sighting));
        },
        editCancel:function(){
            this.editing_record = null;
        },
        editSave:function(){
            this.showSighting(this.sightingID);
            this.$emit('sightingModfied', this.sightingID);
        },
        getBadgeType:function(status){
            if (status.id == this.APIStatuses.accpeted) {
                return 'badge-success';
            }
            if (status.id == this.APIStatuses.pending) {
                return 'badge-warning';
            }
            if (status.id == this.APIStatuses.declined) {
                return 'badge-danger';
            }
            return 'badge-secondary';
        },
        sightingDeleted:function(sightingID){
            if (this.$parent.getNextSightingExists()) {
                this.showSighting(this.$parent.getNextSightingID());
            }
            else{
                $('.modal-close').click();
            }
            this.$emit('sightingModfied', sightingID);
            this.$emit('sightingDeleted', sightingID);
        },
        sightingVettingChanged:function(sightingid, vetted){
            this.editing_taxa=false;
            if (vetted && this.$parent.getNextSightingExists()) {
                this.showSighting(this.$parent.getNextSightingID());
            }
            else{
                // this.loading = true;
                this.showSighting(this.sightingID);
            }
            this.$emit('sightingModfied', this.sightingID);
        },
        setwaiting:function(type){
            this.waiting = type;
        },
        getwaiting:function(){
            return this.waiting;
        },
        setSighting:function (sightingID){
            let query = Object.assign({}, this.$route.query);
            if (sightingID) {
                query.active_sighting = sightingID;
            }
            else{
                delete query.active_sighting;
            }
            this.$router.replace({query: query});

            this.$emit('sightingChanged', sightingID);
        },
        showSighting: function(sightingID, then){
            var self = this;
            this.clearEditingTaxa();
            this.editing_record = null;
            this.show_request_vetting = false;
            this.delete_photos = false;
            self.loading = true;
            if (isNaN(sightingID)) {
                return;
            }


            this.waiting = false;
            this.setSighting(sightingID);

            if (this.marker) {
                this.marker.setMap(null);
                this.marker = null;
            }


            self.sightingID = sightingID;

            var qs = "&include[]=checklist.user.*";
            qs += "&include[]=checklist.location.*";
            qs += "&include[]=checklist.location.parent.*";
            qs += "&include[]=checklist.location.old_parent.*";
            qs += "&include[]=status.*";
            qs += "&include[]=checklist.*";
            qs += "&exclude[]=checklist.sightings";
            qs += "&include[]=taxon.*";
            qs += "&include[]=vetter.*";
            qs += "&include[]=observer_confidence.*";
            qs += "&include[]=type.*";
            qs += "&include[]=life_stage.*";
            qs += "&include[]=request_vetting_user.*";
            self.API({
                endpoint: 'sightings/'+sightingID,
                querystring: qs,
                funcThen: function(response){
                    self.failed_id = null;
            		mr.modals.showModal($('#' + self.uniqueID));
                    self.cleanResponseData(response.data);
                    self.loading = false;
                    self.addPlainMapType();
                    if (then) {
                        then();
                    }
                },
                funcCatch: function(response){
                    self.failed_id = sightingID;
                    self.$emit('sightingChanged', sightingID);
                }
            });
        },
        cleanResponseData: function(data){
            this.sighting = data.sighting;
            // this.editing_record = data.sighting;
            if (this.sighting.photos.length > 0) {
                this.activephoto = this.sighting.photos[0];
            }

            this.sighting.checklist_data = data.checklists ? data.checklists.find(c => c.id == data.sighting.checklist) : null;
            this.sighting.user_data = data.users ? data.users.find(u => u.id == data.sighting.checklist_data.user) : null;
            this.sighting.vetter_data = data.users ? data.users.find(u => u.id == data.sighting.vetter) : null;
            this.sighting.location_data = data.locations ? data.locations.find(u => u.id == data.sighting.checklist_data.location) : null;
            this.sighting.jurisdiction_data = data.locations ? data.locations.find(u => u.id == data.sighting.location_data.parent) : null;
            this.sighting.old_jurisdiction_data = data.locations ? data.locations.find(u => u.id == data.sighting.location_data.old_parent) : null;
            this.sighting.taxon_data = data.taxa ? data.taxa.find(u => u.id == data.sighting.taxon) : null;
            this.sighting.status_data = data.sighting_statuses ? data.sighting_statuses.find(s => s.id == data.sighting.status) : null;
            this.sighting.observer_confidence_data = data.id_confidences ? data.id_confidences.find(c => c.id == data.sighting.observer_confidence) : null;
            this.sighting.type_data = data.sighting_types ? data.sighting_types.find(t => t.id == data.sighting.type) : null;
            this.sighting.life_stage_data = data.life_stages ? data.life_stages.find(l => l.id == data.sighting.life_stage) : null;
            this.sighting.request_vetting_user_data = data.users ? data.users.find(u => u.id == data.sighting.request_vetting_user) : null;
        },
    },
    watch: {
        gMapType: function(){
            this.$store.commit('setgMapPreferenceSightingModal', this.gMapType)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SightingModal.vue